import { useEffect, useState } from "react";
import { Autocomplete } from "@mui/material";
import { useAppSelector } from "@/store/hooks";
import { useTranslate } from "@/hooks";
import { selectScriptList } from "@/store/ses/sesScriptSlice";
import { determineScriptTypeByAction } from "@/helpers";
import { IActionExternal } from "@/types/ses/sesItemConfigTypes";
import { IScriptItem } from "@/types/ses/sesScriptTypes";
import { NoOptionText, RenderOption } from "@/ui";
import { CustomTextField } from "@/ui";
import { ISaveHandlerProps, ISayExternalProps } from "./SayExternal.props";

const SayExternal = ({ action, actionFor, idx, channel, isDisabled, handleSaveActionInStore }: ISayExternalProps): JSX.Element => {
	const [inputScript, setInputScript] = useState<IScriptItem | null>(null); // скрипт

	const scriptList = useAppSelector(selectScriptList); // store - список скриптов

	const translate = useTranslate(); // hook для перевода текста

	useEffect(() => {
		const foundScript = scriptList.data.find((scriptItem) => scriptItem.id === action.script);
		setInputScript(
			foundScript ||
				(action.script === "" ? null : { id: action.script, name: `${action.script} (${translate("title_notFound")})`, type: determineScriptTypeByAction(actionFor) })
		);
	}, [scriptList.data]);

	// обработчик изменения скрипта
	const handleScriptChange = (_e: React.SyntheticEvent<Element, Event>, value: IScriptItem | null): void => {
		const formattedValue = value?.id || "";
		setInputScript(value);
		action.script !== formattedValue && sayExternalActionDataChangeHandler({ script: formattedValue });
	};

	// обработчик изменения данных действия "Запустить скрипт" (say-external)
	const sayExternalActionDataChangeHandler = ({ script }: Partial<ISaveHandlerProps>): void => {
		const data: { channel: string; idx: number; action: Partial<IActionExternal> } = {
			channel,
			idx,
			action: { script: script ?? inputScript?.id },
		};
		handleSaveActionInStore(data);
	};

	return (
		<Autocomplete
			fullWidth
			autoHighlight
			options={scriptList.data.filter(({ type }) => (actionFor.for.includes("robot") ? type === "endpoint" : actionFor.for.includes(type)))}
			value={inputScript}
			onChange={handleScriptChange}
			noOptionsText={<NoOptionText />}
			disabled={isDisabled}
			title={inputScript?.name}
			renderInput={(params) => <CustomTextField {...params} label={translate("input_script")} error={!inputScript} />}
			getOptionLabel={(option) => option.name}
			renderOption={(props, option) => {
				return (
					<RenderOption {...props} key={option.id}>
						{option.name}
					</RenderOption>
				);
			}}
		/>
	);
};

export default SayExternal;
